export default {
  HasAccount: {
    Login: 'Đăng nhập',
    InputPasswordPlease: 'Vui lòng nhập mật khẩu của tài khoản <b>{account}</b> để tiếp tục sử dụng'
  }
}
